// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oNeC","footer":"styles_footer__2egpm","passCodeTooltip":"styles_passCodeTooltip__3nUn2"};